import { render, staticRenderFns } from "./purchaseCompletedLowPrice.vue?vue&type=template&id=ef408e9c&scoped=true"
import script from "./purchaseCompletedLowPrice.vue?vue&type=script&lang=js"
export * from "./purchaseCompletedLowPrice.vue?vue&type=script&lang=js"
import style0 from "./purchaseCompletedLowPrice.vue?vue&type=style&index=0&id=ef408e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef408e9c",
  null
  
)

export default component.exports